module.exports = __webpack_public_path__ + "img/BevFamilyPoint.72ec7f84.png";